var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.SupportApartments.AttachmentTitle"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.SupportApartments.AttachmentTitle_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Investment.Funding.Title")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.Funding.FundingSupportApartments"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.Funding.FundingSupportApartments_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("ul", [
        _vm.isExtension
          ? _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("BudgetaryEstimate.Profits.STEAPlannedAid"))
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "BudgetaryEstimate.Profits.STEAPlannedAid_Instructions"
                    )
                  )
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "BudgetaryEstimate.Investment.Funding.SelfCoveredFunding"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "BudgetaryEstimate.Investment.Funding.OtherGovernmentAid"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$t("BudgetaryEstimate.Investment.Funding.AppliedAid"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-0" }, [
            _vm._v(
              _vm._s(
                _vm.isExtension
                  ? _vm.$t(
                      "BudgetaryEstimate.Investment.Funding.AppliedAid_Instructions"
                    )
                  : _vm.$t(
                      "BudgetaryEstimate.Investment.Funding.AppliedAidBCNew_Instructions"
                    )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _vm.isExtension
          ? _c("li", [
              _c("b", [
                _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Profits.DeferredAid")))
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("BudgetaryEstimate.Profits.DeferredAid_Instructions")
                  )
                )
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.Investment.Funding.SelfCoveredFunding_Details"
            )
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.Investment.Funding.OtherGovernmentAid_Details"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BudgetaryEstimate.Investment.Funding.OtherGovernmentAid_Details_Instructions"
            )
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Expenses")))]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.SupportApartments.Apartment.Title"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.SupportApartments.Apartment.Title_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.SupportApartments.Apartment.Description"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t("BudgetaryEstimate.Investment.SupportApartments.Summary.Title")
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "BudgetaryEstimate.Investment.SupportApartments.Summary.Title_Instructions"
          )
        )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }